module.exports = __webpack_public_path__ + "media/images/pc/banner/winter_campaign_side-81cd1c85ace8df075f446d8b1935419d.png";